import React, { useState } from 'react';
import Checkbox from '@mui/material/Checkbox';
import StatusTabs, { loadTab, storeTab } from '../lists/StatusTabs';
import { GroupList } from './UserGroupsLayout';

// New UI for Group rules (docs/ui_redesign/14-screen-concepts.md, "Users and permissions", option A): the same group
// list as User groups, one tab per module, and each module's rules split into Fields and Buttons, each with its
// Editable box. Reset and Save sit under the rules. GroupRules.js passes its own rules, handlers and buttons.
export function rulesByModule(rules = []) {
	const out = [];
	rules.forEach((rule, index) => {
		const m = rule.Model_def_id;
		let mod = out.find(x => x.id === m);
		if (!mod) { mod = { id: m, types: [] }; out.push(mod); }
		const type = rule.type || 'Other';
		let t = mod.types.find(x => x.type === type);
		if (!t) { t = { type, rules: [] }; mod.types.push(t); }
		t.rules.push({ rule, index });
	});
	return out;
}
const TYPE_TITLE = { Field: 'Fields', Button: 'Buttons' };

export default function GroupRulesLayout({ groups = [], selectedGroup, onSelectGroup, rules = [], onToggle, labelOf = l => l, moduleTitles = {}, dirty, resetButton, saveButton }) {
	const modules = rulesByModule(rules);
	const keys = modules.map(m => 'm' + m.id);
	const [picked, setPicked] = useState(null);
	const tab = keys.includes(picked) ? picked : loadTab('apworks.groupRulesTab', keys, keys[0]);
	const current = modules.find(m => 'm' + m.id === tab);
	return (
		<div className="apw2-ug">
			<div className="apw2-ug-head"><h1>Group rules</h1></div>
			<div className="apw2-ug-layout">
				<GroupList groups={groups} value={selectedGroup} onSelect={onSelectGroup} />
				<section className="apw2-ug-card apw2-ug-rights" aria-label="Group rules">
					{modules.length > 0 && (
						<StatusTabs label="Modules" controls="apw2-gr-panel" value={tab} onChange={k => { storeTab('apworks.groupRulesTab', k); setPicked(k); }}
							tabs={modules.map(m => ({ key: 'm' + m.id, label: moduleTitles[m.id] || `Group ${m.id}` }))} />
					)}
					<div id="apw2-gr-panel" role="tabpanel" aria-labelledby={'apw2-stab-' + tab} className="apw2-gr-panel">
						{!current && <p className="apw2-ug-none">Choose a group to see its rules.</p>}
						{current && current.types.map(t => (
							<div key={t.type} className="apw2-gr-group">
								<h2>{TYPE_TITLE[t.type] || t.type}<span>{t.rules.filter(x => x.rule.editable === '1').length} of {t.rules.length} editable</span></h2>
								<ul>
									{t.rules.map(({ rule, index }) => (
										<li key={rule.path + '_' + index}>
											<label>
												<Checkbox size="small" checked={rule.editable === '1'} onChange={() => onToggle(index)} />
												<span>{labelOf(rule.label)}</span>
											</label>
										</li>
									))}
								</ul>
							</div>
						))}
					</div>
					<div className="apw2-savebar" role="region" aria-label="Save changes">
						<span className="apw2-savebar-note">{dirty ? <b>Unsaved changes</b> : 'No changes'}</span>
						<span className="apw2-grow" />
						{resetButton}
						{saveButton}
					</div>
				</section>
			</div>
		</div>
	);
}
